module.exports = __webpack_public_path__ + "static/media/shell32_153.51e66ed0.ico";